import React from 'react'
import { Col, List, Row, Typography } from 'antd'
import CustomList from '../../../components/Shared/CustomList'
import CustomVideo from '../../../components/Shared/CustomVideo'
import { GeneralTitle } from '../../../components/Shared'

const { Title, Paragraph } = Typography

const services = [
	'Content',
	'Research',
	'E-commerce Marketing',
	'Strategy',
	'SEM',
	'SEO'
]

const DigitalMarketing = () => {
	return (
		<>
			<GeneralTitle>Digital Marketing</GeneralTitle>

			<Row gutter={[20, 20]} justify="space-between" align="middle">
				<Col xs={24} sm={24} md={14} lg={14}>
					<Title level={4}>
						Build your brand. Grow your business.
					</Title>
					<Paragraph>
						A successful branding campaign can drive your corporate
						goals and magnify the impact of your marketing and
						communications efforts immediately, setting the tone for
						all future communications.
					</Paragraph>
					<Paragraph>
						Whether you have a national or international audience or
						simply are looking to strengthen your brand inside the
						Web, we can help you realize your potential and better
						communicate with all of your audiences.
					</Paragraph>
					<CustomList
						dataSource={services}
						renderItem={(item) => <List.Item>{item}</List.Item>}
					/>
				</Col>
				<Col xs={24} sm={24} md={10} lg={10}>
					<img
						width="100%"
						src={`${process.env.PUBLIC_URL}/branding/webackit-services-diagram-marketing.svg`}
						alt="WordPress Services Diagram"
					/>
				</Col>
			</Row>

			<CustomVideo
				src="https://webackit.com/videos/webackit-elevating-businesses-digitally.mp4"
				type="video/mp4"
				styleProps={{
					width: '100%'
				}}
			/>
		</>
	)
}

export default DigitalMarketing
